export default __webpack_public_path__ + "static/media/VastrakalaLogoBlack.79350862.svg";